import { ProductType } from '@inter-ikea-storageone/range';
import AccessoriesDrawersInfo from 'components/ProductSidebar/CategoryWidget/AccessoriesDrawersInfo';
import AccessoriesShelvesInfo from 'components/ProductSidebar/CategoryWidget/AccessoriesShelvesInfo';
import { ProductListConfig } from 'rangeConfig/@types';
import addAccessory from 'rangeConfig/pax/behaviors/addAccessory';
import removeAllClothRailStorageCasesInScene from 'rangeConfig/pax/behaviors/removeAllClothRailStorageCasesInScene';
import removeAllDrawerAccessoriesFromScene from 'rangeConfig/pax/behaviors/removeAllDrawerAccessoriesFromScene';
import removeAllShelfAccessoriesFromScene from 'rangeConfig/pax/behaviors/removeAllShelfAccessoriesFromScene';
import { matchAccesoriesToFramesInScene } from 'rangeConfig/pax/filters/mainMenuProductFilters';
import { getAccessoryHoverImage } from 'rangeConfig/pax/rules/images';
import { noProductsWithTypesInScene } from 'rangeConfig/shared/rules/noneOptionSelectedRules';

const accessoriesProductListConfig: ProductListConfig = {
  cardsTitle: 'name',
  cardsSubtitle: 'typeName, designText',
  infoButtonAriaLabel:
    'typeName, communicatedDimensionsLocalized.width communicatedDimensionsLocalized.unit storageone.productCardTextWide',
  productCardHoverImage: getAccessoryHoverImage,
  behaviors: {
    productClicked: [addAccessory],
    productDropped: [addAccessory]
  },
  productFilters: [matchAccesoriesToFramesInScene],
  sortOrder: [],
  cluster: ['type', 'name', 'typeName', 'designText'],
  categories: [
    {
      id: 'shelves-boxes',
      categoryTitle: 'storageone.productListAccessoriesCategoryShelvesTitle',
      widgets: [{ component: AccessoriesShelvesInfo }],
      products: [
        { path: 'type', value: ProductType.PAX_SKUBB_STORAGE_CASES },
        { path: 'type', value: ProductType.PAX_SKUBB_SHOE_BOXES },
        { path: 'type', value: ProductType.PAX_HEMMAFIXARE_STORAGE_CASE },
        { path: 'type', value: ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH },
        { path: 'type', value: ProductType.PAX_SKUBB_STORAGE_BOXES },
        { path: 'type', value: ProductType.PAX_HEMMAFIXARE_SHOE_BOX },
        { path: 'type', value: ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP },
        { path: 'type', value: ProductType.PAX_SKUBB_STORAGE_CASE_WRAP },
        { path: 'type', value: ProductType.PAX_SHOE_MAT }
      ],
      cluster: ['design', 'type'],
      noneOption: {
        title: 'storageone.productListNoShelfOrganisersOptionTitle',
        subtitle: 'storageone.productListNoShelfOrganisersOptionSubtitle',
        behaviors: { removeProducts: [removeAllShelfAccessoriesFromScene] },
        selected: noProductsWithTypesInScene([
          ProductType.PAX_SKUBB_STORAGE_CASES,
          ProductType.PAX_SKUBB_SHOE_BOXES,
          ProductType.PAX_HEMMAFIXARE_STORAGE_CASE,
          ProductType.PAX_HEMMAFIXARE_STORAGE_CASE_HIGH,
          ProductType.PAX_SKUBB_STORAGE_BOXES,
          ProductType.PAX_HEMMAFIXARE_SHOE_BOX,
          ProductType.PAX_SKUBB_STORAGE_BOXES_W_COMP,
          ProductType.PAX_SKUBB_STORAGE_CASE_WRAP,
          ProductType.PAX_SHOE_MAT
        ])
      }
    },
    {
      id: 'drawer-boxes-and-mats',
      categoryTitle: 'storageone.productListAccessoriesCategoryDrawersTitle',
      widgets: [{ component: AccessoriesDrawersInfo }],
      products: [
        { path: 'type', value: ProductType.PAX_DRAWER_BOX_ASM },
        { path: 'type', value: ProductType.PAX_DRAWER_MAT }
      ],
      cluster: ['design', 'type'],
      noneOption: {
        title: 'storageone.productListNoDrawerOrganisersOptionTitle',
        subtitle: 'storageone.productListNoDrawerOrganisersOptionSubtitle',
        behaviors: { removeProducts: [removeAllDrawerAccessoriesFromScene] },
        selected: noProductsWithTypesInScene([
          ProductType.PAX_DRAWER_BOX_ASM,
          ProductType.PAX_DRAWER_MAT
        ])
      }
    },
    {
      id: 'hanging-storage-case',
      categoryTitle: 'storageone.productListCategoryTitleClothRail',
      cardsSubtitle: 'typeName, designText communicatedSizeText',
      products: [{ path: 'type', value: ProductType.PAX_SKUBB_HANGING_STORAGE }],
      noneOption: {
        title: 'storageone.productListNoClothRailOrganisersOptionTitle',
        subtitle: 'storageone.productListNoClothRailOrganisersOptionSubtitle',
        behaviors: { removeProducts: [removeAllClothRailStorageCasesInScene] },
        selected: noProductsWithTypesInScene([ProductType.PAX_SKUBB_HANGING_STORAGE])
      }
    }
  ]
};

export default accessoriesProductListConfig;
